module.exports = __webpack_public_path__ + "img/box9-01.61bd278d.png";